import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'campanyaEstado'
})
export class CampanyaEstadoPipe implements PipeTransform {

  transform(value: unknown): unknown {
    let label = '';
    let cssClass = '';

    switch (value) {
      case '1':
        label = 'Pendiente';
        cssClass = 'badge-estado-info';
        break;
      case '2':
        label = 'Parcialmente Asignada';
        cssClass = 'badge-estado-warning';
        break;
      case '3':
        label = 'Asignada';
        cssClass = 'badge-estado-warning';
        break;
      case '4':
        label = 'En proceso';
        cssClass = 'badge-estado-proceso';
        break;
      case '6':
        label = 'Completada';
        cssClass = 'badge-estado-success';
        break;
      case '8':
        label = 'Incidencia en Recogida';
        cssClass = 'badge-estado-danger';
        break;
      default:
        return value;
    }

    return `<span class="badge ${cssClass}">${label}</span>`;
  }

}
